import React from "react";
import { Box, Card, CardContent, Typography, Button } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { InputField } from "../components/FormFields";

// Props:
// - initialValue: string
// - onSubmit: (values) => Promise
// - loading: boolean
export default function RegisterMobile({
  initialValue = { mobile: "", email: "" },
  onSubmit,
  loading = false,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "80vh",
        backgroundColor: "#f5f6fa",
        p: 2,
      }}
    >
      <div
        className="card shadow-sm border-0"
        style={{ maxWidth: 420, width: "100%", borderRadius: "1rem" }}
      >
        <div className="card-body p-4">
          <Typography
            variant="h6"
            align="center"
            sx={{ fontWeight: 600, color: "#222", mb: 1 }}
          >
            Enter Your Registered Mobile & Email Address
          </Typography>
          {/* <Typography
            variant="body2"
            align="center"
            sx={{ color: "text.secondary", mb: 3 }}
          >
            We’ll verify your number to continue to the profiling form
          </Typography> */}

          <Formik
            initialValues={{
              mobile: initialValue.mobile,
              email: initialValue.email,
              consent: false,
            }}
            validationSchema={Yup.object({
              mobile: Yup.string()
                .matches(
                  /^[0-9]{10}$/,
                  "Mobile number must be exactly 10 digits"
                )
                .required("Mobile number is required"),
              email: Yup.string()
                .email("Please enter a valid email address")
                .required("Email is required"),
              consent: Yup.boolean()
                .oneOf([true], "You must agree to the consent")
                .required("Consent is required"),
            })}
            onSubmit={async (values) => {
              if (onSubmit) await onSubmit({ ...values });
            }}
          >
            {({
              isSubmitting,
              errors,
              touched,
              isValid,
              values,
              setFieldValue,
            }) => (
              <Form>
                <div className="d-flex flex-column align-items-center gap-3 mt-3">
                  <div className="w-100" style={{ maxWidth: 300 }}>
                    <label className="my-2 fw-bold">
                      Mobile Number <span style={{ color: "red" }}>*</span>
                    </label>
                    <InputField
                      name="mobile"
                      placeholder="10-digit mobile number"
                      type="number"
                      required
                      fullWidth
                    />
                    {errors.mobile && touched.mobile && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "5px",
                        }}
                      >
                        {errors.mobile}
                      </div>
                    )}
                  </div>
                  <div className="w-100" style={{ maxWidth: 300 }}>
                    <label className="my-2 fw-bold">
                      Email Address <span style={{ color: "red" }}>*</span>
                    </label>
                    <InputField
                      name="email"
                      placeholder="Enter your email"
                      type="email"
                      required
                      fullWidth
                    />
                    {errors.email && touched.email && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "5px",
                        }}
                      >
                        {errors.email}
                      </div>
                    )}
                  </div>
                  <div className="w-100" style={{ maxWidth: 300 }}>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="consent"
                        id="consentCheckbox"
                        checked={values.consent}
                        onChange={(e) => {
                          setFieldValue("consent", e.target.checked);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="consentCheckbox"
                        style={{
                          fontSize: "9px",
                        }}
                      >
                        <span style={{ color: "red" }}>*</span> I agree to
                        provide the above-mentioned personal information for the
                        F.P. Workshop and hereby give my consent to receive
                        communications related to products, services, and
                        updates.
                      </label>
                    </div>
                    {errors.consent && touched.consent && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "5px",
                        }}
                      >
                        {errors.consent}
                      </div>
                    )}
                  </div>
                  <button
                    type="submit"
                    className="btn btn-primary fw-semibold px-4 py-2 shadow-sm"
                    disabled={isSubmitting || loading || !isValid}
                  >
                    {loading ? "Verifying..." : "Continue"}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </Box>
  );
}
